import { BrandMark } from '../brand/BrandMark'
import { type ReactNode } from "react";
import { Col, Row } from "react-bootstrap";

export function AuthLayout({
  badge,
  title,
  description,
  children,
  variant = "signin",
}: {
  badge: string;
  title: string;
  description: string;
  children: ReactNode;
  variant?: "signin" | "signup" | "selection";
}) {
  return (
    <main
      className={`signin-shell ${variant === "signup" ? "signup-shell" : ""}`}
    >
      <Row className="justify-content-center signin-shell__row">
        <Col xl={10} lg={11}>
          <div className="signin-card">
            <section
              className="signin-card__intro"
              aria-labelledby="crm-signin-intro"
            >
              <div className="mb-3"><BrandMark size={56} /></div>
          <span className="signin-card__eyebrow">{variant === "selection" ? "Business access" : "SmoothBadger CRM"}</span>
              <h1 id="crm-signin-intro" className="signin-card__title">
                {variant === "selection" ? "Choose the business you want to manage first." : variant === "signup"
                  ? "Build stronger customer relationships."
                  : "Manage customers, actions and orders in one place."}
              </h1>
              <p className="signin-card__description">
                {variant === "selection" ? "Pick the business you want to open now. You can switch again later from the header." : variant === "signup"
                  ? "Start your business workspace and bring customer details, team actions and orders together."
                  : "Sign in to your CRM workspace, stay close to your customers and keep your next actions moving."}
              </p>
              <div className="info-panel mb-3">
                <div className="info-panel__content">
                  <div className="info-panel__title">
                    {variant === "selection" ? "Why this step appears" : "Built for customer relationships"}
                  </div>
                  <div className="info-panel__body">
                    {variant === "selection" ? "Choose your active business before loading customers, actions, orders and settings." : "Keep account details, contacts, notes and follow-ups connected in one workspace."}
                  </div>
                </div>
              </div>
              <div className="info-panel info-panel--success mb-0">
                <div className="info-panel__content">
                  <div className="info-panel__title">
                    {variant === "selection" ? "You can switch later" : "Multiple businesses supported"}
                  </div>
                  <div className="info-panel__body">
                    {variant === "selection" ? "This only sets your initial workspace after sign-in. It does not limit access to your other businesses." : "If your account has access to more than one business, you will choose the workspace to open after sign-in."}
                  </div>
                </div>
              </div>
            </section>
            <section
              className="signin-card__panel"
              aria-labelledby="crm-signin-title"
            >
              <div className="signin-form__header">
                <span className="signin-form__badge">{badge}</span>
                <h2 id="crm-signin-title" className="signin-form__title">
                  {title}
                </h2>
                <p className="signin-form__text">{description}</p>
              </div>
              {children}
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
}
